import gql from 'graphql-tag';
import { miniUserFragment } from '../fragments/mini-user.fragment';

export const getMeSubscription = gql`
  subscription me {
    me {
      ...miniUserFragment
    }
  }
  ${miniUserFragment}
`;
